import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import yaml from 'js-yaml';
import { alertAuthExpired, getFfdUrl } from 'shared/api/ffdClient';

export const submitLimeStart = async (
  authToken: string,
  cognitoId: string,
  study_name: string,
  cfd_id: string
): Promise<void> => {
  // Generate random file names
  const yamlFileName = `${uuidv4()}.yml`;
  const yamlFilePath = `from-web-app/${cognitoId}/lime-config/${yamlFileName}`;

  // Create YAML content
  const yamlConfig = yaml.dump({
    study_name: study_name,
    trial_id: cfd_id
  });

  // Upload YAML file to S3
  try {
    const task = uploadData({
      path: yamlFilePath,
      data: yamlConfig
    });
    await task.result;
  } catch (error) {
    alert("Failed to upload .YAML to the server.");
  }

  // Send API request using uploaded YAML file
  try {
    const response = await fetch(getFfdUrl("/trials/lime_start"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken,
      },
      body: JSON.stringify({ yamlFilePath }),
    });

    const data = await response.json();
    alert(data.text);
  } catch (error) {
    alertAuthExpired();
  }
};
